import { Container } from "./styles";
// import owais from "../../assets/iowais.png";
import tailwind from "../../assets/tailwind.svg";
import nextjs from "../../assets/nextjs.svg";
import htmlIcon from "../../assets/html-icon.svg";
import cssIcon from "../../assets/css-icon.svg";
import jsIcon from "../../assets/js-icon.svg";
import nodeIcon from "../../assets/node-icon.svg";
import awsIcon from "../../assets/amazon-aws.png";
import reactIcon from "../../assets/react-icon.svg";
import typescriptIcon from "../../assets/typescript-icon.svg";
import mongodb from "../../assets/mongodb.svg";
import bootstrapIcon from "../../assets/bootstrap-icon.svg";
import ScrollAnimation from "react-animate-on-scroll";
import postgresql from "../../assets/postgresql.svg";
import jest from "../../assets/jest.svg";
import python from "../../assets/python.svg";
import docker from "../../assets/docker.svg";
import csharpDotnet from "../../assets/csharp-dotnet.svg";
import claudeCode from "../../assets/claude-code.svg";
import angular from "../../assets/angular.svg";
import sassIcon from "../../assets/sass-icon.svg";
import mysqlIcon from "../../assets/mysql-icon.svg";
import githubIcon from "../../assets/github.svg";
import shopifyIcon from "../../assets/shopify-logo.svg";
import fastapiIcon from "../../assets/fastapi.svg";
import expressIcon from "../../assets/express.svg";
import flaskIcon from "../../assets/flask.svg";
import dotnetIcon from "../../assets/dotnet.svg";
import restApiIcon from "../../assets/rest-api.svg";
import graphqlIcon from "../../assets/graphql.svg";
import gitIcon from "../../assets/git.svg";
import bitbucketIcon from "../../assets/bitbucket.svg";
import jiraIcon from "../../assets/jira.svg";
import scikitlearnIcon from "../../assets/scikitlearn.svg";
import pandasIcon from "../../assets/pandas.svg";

const skillGroups = [
  {
    title: "Languages",
    skills: [
      { name: "JavaScript", icon: jsIcon },
      { name: "TypeScript", icon: typescriptIcon },
      { name: "Python", icon: python },
      { name: "C#", icon: csharpDotnet },
      { name: "HTML5", icon: htmlIcon },
      { name: "CSS3", icon: cssIcon },
    ],
  },
  {
    title: "Frontend",
    skills: [
      { name: "React.js", icon: reactIcon },
      { name: "Next.js", icon: nextjs },
      { name: "React Native", icon: reactIcon },
      { name: "Angular", icon: angular },
      { name: "Tailwind CSS", icon: tailwind },
      { name: "Bootstrap", icon: bootstrapIcon },
      { name: "SASS/SCSS", icon: sassIcon },
      { name: "Shopify", icon: shopifyIcon },
    ],
  },
  {
    title: "Backend",
    skills: [
      { name: "Node.js", icon: nodeIcon },
      { name: "Express.js", icon: expressIcon },
      { name: "Flask", icon: flaskIcon },
      { name: "FastAPI", icon: fastapiIcon },
      { name: ".NET", icon: dotnetIcon },
      { name: "REST APIs", icon: restApiIcon },
      { name: "GraphQL", icon: graphqlIcon },
    ],
  },
  {
    title: "Databases",
    skills: [
      { name: "MongoDB", icon: mongodb },
      { name: "PostgreSQL", icon: postgresql },
      { name: "MySQL", icon: mysqlIcon },
    ],
  },
  {
    title: "Cloud & DevOps",
    skills: [
      { name: "AWS", icon: awsIcon },
      { name: "Docker", icon: docker },
    ],
  },
  {
    title: "Tools & Testing",
    skills: [
      { name: "Git", icon: gitIcon },
      { name: "GitHub", icon: githubIcon },
      { name: "Bitbucket", icon: bitbucketIcon },
      { name: "Jira", icon: jiraIcon },
      { name: "Claude Code", icon: claudeCode },
      { name: "Jest", icon: jest },
    ],
  },
  {
    title: "Machine Learning",
    skills: [
      { name: "scikit-learn", icon: scikitlearnIcon },
      { name: "Pandas", icon: pandasIcon },
    ],
  },
];

export function About() {
  return (
    <Container id="about">
      <div className="about-text">
        <ScrollAnimation animateIn="fadeInLeft">
          <h2>About me</h2>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.1 * 1000}>
          <p>
            Hi, I'm Owais 👋 a Full Stack Software Engineer who loves turning ideas into products people genuinely enjoy using. Over the past 2+ years I've built SaaS dashboards, client portals, AI powered platforms and mobile apps, taking them from a Figma design all the way to production.
          </p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.2 * 1000}>
          <p>
            Most of my days are spent in <span className="highlight">React.js, Next.js, Node.js and TypeScript</span>, backed by <span className="highlight">PostgreSQL or MongoDB</span>. I also build with <span className="highlight">C#/.NET and Python</span>, create mobile apps with <span className="highlight">React Native</span>, ship with <span className="highlight">AWS and Docker</span>, and bring in machine learning with <span className="highlight">scikit-learn and Pandas</span> when a product needs it. I'm just as comfortable crafting a smooth, responsive frontend as I am designing a backend that scales.
          </p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.3 * 1000}>
          <p>
            I use <span className="highlight">Claude Code</span> every day to speed up my workflow. It takes care of the repetitive parts, so I can put my energy into clean architecture and the small details that make a product feel right. I work comfortably in agile teams with Git, Jira and code reviews, and I care about writing code that the next developer will actually enjoy reading.
          </p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.4 * 1000}>
          <p>
            If you're building something and need someone who cares about quality as much as you do, I'd love to hear about it. Let's connect!
          </p>
        </ScrollAnimation>
      </div>

      <div className="about-skills">
        <ScrollAnimation animateIn="fadeInRight">
          <h3>What I work with</h3>
        </ScrollAnimation>
        {skillGroups.map((group, groupIndex) => (
          <ScrollAnimation
            key={group.title}
            animateIn="fadeInUp"
            delay={0.1 * groupIndex * 1000}
          >
            <div className="skill-group">
              <h4>{group.title}</h4>
              <div className="hard-skills">
                {group.skills.map((skill) => (
                  <div className="hability" key={skill.name}>
                    <img src={skill.icon} alt={skill.name} />
                    <span>{skill.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </ScrollAnimation>
        ))}
      </div>
      {/* <div className="about-image">
        <ScrollAnimation animateIn="fadeInRight" delay={0.20 * 1000}>
          <img src={owais} alt="Owais" />
        </ScrollAnimation>
      </div> */}
    </Container>
  )
}
